import { AppConfig } from '../../../common/model/config';
import { portoVelhoShoppingTheme } from '../themes/porto-velho-shopping.theme';
import { ORDER_TYPE_COUNTER } from '../../../common/model/order-types';

export const portoVelhoShoppingConfig: AppConfig = {
  appName: 'porto-velho',
  appTitle: 'Porto Velho Shopping',
  appDescription: 'Peça aqui nos restaurantes do Porto Velho Shopping.',
  aggregator: 227,
  brand: 217,
  theme: portoVelhoShoppingTheme,
  faviconPath: '/favicons/favicon-porto-velho-shopping.ico',
  defaultOrderType: ORDER_TYPE_COUNTER,
  featureFlags: {
    embeddedApplication: true,
    getBrandThemeFromBackend: false,
    shuffleCompanyArray: true,
    gmapsAddress: false,
    showOptionsTabsAggregators: false,
    filterByDeliveryArea: false,
    useLocalAggregatorHeaderImg: false,
    removeLogoFromTheApp: true,
  },
};
